export default {
      id: "h-04-usage",
      viewBox: "0 0 297 236",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#h-04",
      toString: function () {
        return this.url;
      }
    }